import { render, staticRenderFns } from "./JInputPop.vue?vue&type=template&id=332d7a08&scoped=true"
import script from "./JInputPop.vue?vue&type=script&lang=js"
export * from "./JInputPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332d7a08",
  null
  
)

export default component.exports